// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"984":"css/app.7000","6900":"css/admin-app.7000"}[chunkId] + ".css";
};